import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { ThemeProvider } from '@material-ui/styles';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import theme from './theme';
import selectTableSlice from '../selectTableSlice';
import { useTranslation } from 'react-i18next';

const SelectTableFooter = ({ numberOfFilteredItems, itemsPerPage, actPage, setPage }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const items = useSelector(state => state.designList.items);
	const vinNom = useSelector(state => state.designList.inputParameters.vinNom);
	const dispatch = useDispatch();

	const handleChangePage = (_event, page) => {
		setPage(page);
	};

	const handleChangeRowsPerPage = event => {
		setItemsPerPage(event.target.value);
		setPage(0);
	};

	const setItemsPerPage = numItems => {
		dispatch(selectTableSlice.actions.setItemsPerPage(numItems));
	};

	const isThereVinNomCalculation = () => items.length > 0 && vinNom !== '';

	const isThereParcialPrice = () => items.filter(item => item.priceIsPartial).length > 0;

	const shouldShowFooterMessage = () => isThereVinNomCalculation() || isThereParcialPrice();

	return (
		<TableFooter classes={{ root: classes.tableFooterRoot }}>
			<Grid
				container
				justify={shouldShowFooterMessage() ? 'space-between' : 'flex-end'}
				alignItems="center"
				className={classes.tableFooterContainer}>
				{shouldShowFooterMessage() && (
					<Grid item>
						{isThereParcialPrice() && (
							<Typography variant="caption" color="textSecondary" className={classes.vinNomNote}>
								{t('components.selectTable.footer.messages.parcialPrice')}
							</Typography>
						)}
						{isThereVinNomCalculation() && (
							<Typography variant="caption" color="textSecondary" className={classes.vinNomNote}>
								{t('components.selectTable.footer.messages.vinNomCalc') + ' (' + vinNom + ' V).'}
							</Typography>
						)}
					</Grid>
				)}

				<Grid item className={classes.footerPagination}>
					<ThemeProvider theme={theme}>
						<TablePagination
							rowsPerPageOptions={[10, 20, 50]}
							component="div"
							count={numberOfFilteredItems}
							rowsPerPage={itemsPerPage}
							page={actPage}
							backIconButtonProps={{
								'aria-label': 'Previous Page',
								title: t('components.selectTable.footer.paginationText.previousPage'),
								className: classes.focusableButton
							}}
							nextIconButtonProps={{
								'aria-label': 'Next Page',
								title: t('components.selectTable.footer.paginationText.nextPage'),
								className: classes.focusableButton
							}}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
							labelRowsPerPage={t('components.selectTable.footer.paginationText.rowsPerPage')}
							labelDisplayedRows={({ from, to, count }) => {
								return `${from}-${to}` + ` ${t('components.selectTable.footer.paginationText.of')} ` + `${count}`;
							}}
						/>
					</ThemeProvider>
				</Grid>
			</Grid>
		</TableFooter>
	);
};

SelectTableFooter.propTypes = {
	numberOfFilteredItems: PropTypes.number.isRequired,
	itemsPerPage: PropTypes.number.isRequired,
	actPage: PropTypes.number.isRequired,
	setPage: PropTypes.func.isRequired
};

export default SelectTableFooter;
